import { CheckboxField } from "@/components/ui/form/fields/check-box-field/check-box";

import { useReservationRequiredPlanSelectForReservation } from "./hooks";

export const QuestionReservationRequiredPlanSelectForReservation = () => {
	const { requiredPlanSelectForReservation, onSetRequiredPlanSelectForReservation } =
		useReservationRequiredPlanSelectForReservation();

	const label = "予約時のプラン選択を必須にする";

	return (
		<CheckboxField
			value={requiredPlanSelectForReservation.value}
			errorMessage={requiredPlanSelectForReservation.error}
			label={label}
			handleChange={onSetRequiredPlanSelectForReservation}
		/>
	);
};
